export enum EnrolmentOutcome {
  Competent,
  PartiallyCompetent,
  NotYetCompetent,
}
